<template>
<div>
    <div class="flex-display top-bar">

      <div class="back-button">
          <i class="back-icon" data-feather="chevron-left"></i>
      </div> 

      <h2 class=" text-primary-color"> Title </h2>

      <div class="flex-display right-in-flex">

           <i class="icons-top-bar" data-feather="search"></i>

           <i class="icons-top-bar" data-feather="message-circle"></i>

           <i class="icons-top-bar" data-feather="bell"></i>

           <div class="vertical-line"> </div>

           <h3 class="users-name"> John </h3>

           <jbsAvatar src="https://jobase1.s3.us-east-1.amazonaws.com/images/user/f6c185bd-4a31-4001-b06b-52fea9e08157/bd09a472-6aa6-4855-b26d-6196356202e1.jpg?AWSAccessKeyId=AKIA5KNIXBYXLB55R3X7&Expires=1602691090&Signature=ainuGA1ZVYuSBIoobmlAr%2F9jKd0%3D" withBorder ></jbsAvatar>
      
        </div>
    </div>
  <div class="upper-buttons-row flex-display">
    <jbsButton class="primary-button"> All Properties</jbsButton>
    <jbsButton class="secondary-button "> My Properties</jbsButton>
    <jbsButton class="primary-button create-button right-in-flex" icon="fas fa-plus" >Create New Property</jbsButton>
  </div>
  <div class="cards-parent">
    <div class="property-parent text-secondary-color"  v-for="property in this.properties" :key="property.propertyid">
     
        <img :src="property.imageurl[0]" class="image" >

        <jbsCard class="property-card" >
          
           <div class="flex-display">
                <p class="property-name text-primary-color"> {{property.propertyname}}</p>

                <jbsDropdown class="right-in-flex">

                <i class="fas fa-bars"></i>
                    
                <template v-slot:dropdown>
                    <jbsDropdownMenu>

                        <jbsDropdownItem icon="far fa-edit">
                                    Edit Property
                        </jbsDropdownItem>

                        <jbsDropdownItem class="danger-color" icon="far fa-trash-alt">
                                    Delete Property
                        </jbsDropdownItem>

                    </jbsDropdownMenu>
                </template>

                </jbsDropdown>
           </div>

           <div class="line-on-card"> 
              <i class="fas fa-map-marker-alt"></i> <p class="p-property-info property-address"> {{ property.address }} </p>
           </div>

            <div class="line-on-card"> 
              <i class="fas fa-suitcase"></i> <p class="p-property-info"> Assets: 
                 <span style="font-weight: 700;"> {{ property.machinecount }} </span> </p>
            </div>

            <div class="flex-display last-line"> 
              <div class="text-primary-color">
                   <i class="far fa-user-circle"></i> <p class="p-user-info ">   {{ property.ownerfirstname + " " + property.ownerlastname }} </p>
              </div>
              <jbsButton class="primary-color-background right-in-flex view-button" icon="fas fa-angle-right"> View more</jbsButton>
            </div>  
        </jbsCard>

    </div>
  </div>
</div>
</template>

<script>
import jbsButton from "@/custom-components-test/jbsButton.vue"
import jbsCard from "@/custom-components-test/jbsCard.vue"
import jbsDropdown from "@/custom-components-test/jbsDropdown.vue"
import jbsDropdownMenu from "@/custom-components-test/jbsDropdownMenu.vue"
import jbsDropdownItem from "@/custom-components-test/jbsDropdownItem.vue"
import jbsAvatar from "@/custom-components-test/jbsAvatar.vue"

import EventService from "@/services/EventService.js";

export default {
components:{
    jbsButton,
    jbsCard,
    jbsDropdown,
    jbsDropdownMenu,
    jbsDropdownItem,
    jbsAvatar
},
data(){
    return {
        properties: null
    }
},
created(){
        EventService.getAllProperties()
      .then(response => {
        this.properties = response.data.propertylist;
      });
},
}
</script>

<style scoped>
   .top-bar{
       margin-bottom: 25px;
   }
   .users-name{
       display: inline-block;
    vertical-align: text-bottom;
    margin-right: 10px;
   }
   .vertical-line{
       width: 0px;
       height: 42px;
       border-left: 1px solid #C4C4C4;
       display: inline-block;
    margin: 0px 35px 0px 15px;
   }
   .icons-top-bar{
       margin: 15px;
   }
   .back-button{
       background-color: white;
       max-height: 37px;
       min-height: 37px;
       border-radius: 50%;
       margin: 0px 20px 0px 45px;
   }
   .back-icon{
    height: 27px;
    padding: 5px;
    width: 27px;
   }
   .last-line{
       margin-right: 10px;
   }

   .upper-buttons-row{
       margin-left: 45px;
       margin-bottom: -10px;
   }
   .cards-parent{
       display: flex;
       flex-wrap: wrap;
       justify-content: space-evenly;
   }

  .property-parent{
    margin: 35px;
    display: inline-block;
    }
  
  .image{
    display: block;
    max-height: 210px;
    width: 390px;
    min-height: 210px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.05));
  }

  .property-card{
    margin: 0;
    min-width: 368px;
    max-width: 368px;
    border-radius: 0 0 10px 10px;
  }

  .property-name{
        display: inline-block;
        color: #0C1827;
        margin-left: 11px;
        margin-top: 3px;
        margin-bottom: 3px;
        font-weight: 600;
        font-size: 22px;
  }
   .p-property-info{
       font-weight: 400;
       font-size: 18px;
       display: inline-block;
       margin: 0;
       margin-left: 7px;
   }
   .p-user-info{
       font-weight: 500;
       font-size: 16px;
       display: inline-block;
       margin: 0;
       margin-left: 7px;
   }
   .property-address{
       text-decoration: underline;
   }
   .line-on-card{
       margin: 10px 0px 10px 10px;
   }
   .flex-display{
       display: flex;
       align-items: center;
   }
   .right-in-flex{
       margin-left: auto;
   }
   .view-button{
        margin-right: 0px;
        margin-bottom: 0px;
   }
   .create-button{
        margin-right: 50px;
   }

</style>